import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { expandRangesWindow } from "@/components/nft-picker/NftPicker.utils";
import type { TokenRange } from "@/components/nft-picker/NftPicker.types";
import { toDecimalString } from "../utils";
import type { TokenWindowEntry } from "../types";
export function useVisibleTokenWindow(ranges, firstTokenIndex, lastTokenIndex, tokens) {
  const $ = _c(9);
  let t0;
  bb0: {
    if (lastTokenIndex < firstTokenIndex) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    if (tokens) {
      let t1;
      if ($[1] !== firstTokenIndex || $[2] !== lastTokenIndex || $[3] !== tokens) {
        t1 = tokens.slice(firstTokenIndex, lastTokenIndex + 1).map(_temp);
        $[1] = firstTokenIndex;
        $[2] = lastTokenIndex;
        $[3] = tokens;
        $[4] = t1;
      } else {
        t1 = $[4];
      }
      t0 = t1;
      break bb0;
    }
    const windowSize = lastTokenIndex - firstTokenIndex + 1;
    let t1;
    if ($[5] !== firstTokenIndex || $[6] !== ranges || $[7] !== windowSize) {
      t1 = expandRangesWindow(ranges, firstTokenIndex, windowSize).map(_temp2);
      $[5] = firstTokenIndex;
      $[6] = ranges;
      $[7] = windowSize;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    t0 = t1;
  }
  return t0;
}
function _temp2(tokenId) {
  return {
    tokenId,
    decimalId: toDecimalString(tokenId),
    xtdh: 0
  };
}
function _temp(token) {
  return {
    tokenId: token.tokenId,
    decimalId: toDecimalString(token.tokenId),
    xtdh: token.xtdh
  };
}